import * as types from "./actionTypes";

export const createAddress = (data = {}) => ({
  type: types.CREATE_ADDRESS,
  data,
});
export const updateAddress = (data = {}) => ({
  type: types.UPDATE_ADDRESS,
  data,
});
export const getAllAddress = (payload = {}) => ({
  type: types.GET_ALL_ADDRESS,
  payload,
});
export const getAllAddressResponse = (payload = []) => ({
  type: types.GET_ALL_ADDRESS_RESPONSE,
  payload,
});
export const getAddressById = (payload = {}) => ({
  type: types.GET_ADDRESS,
  payload,
});
export const getAddressByIdResponse = (payload = []) => ({
  type: types.GET_ADDRESS_RESPONSE,
  payload,
});

// SALES
export const getTotalSales = (payload = {}) => ({
  type: types.GET_TOTAL_SALES,
  payload,
});
export const getTotalSalesResponse = (payload = {}) => ({
  type: types.GET_TOTAL_SALES_RESPONSE,
  payload,
});
// orders
export const getTotalOrders = (payload = {}) => ({
  type: types.GET_TOTAL_ORDERS,
  payload,
});
export const getTotalOrdersResponse = (payload = {}) => ({
  type: types.GET_TOTAL_ORDERS_RESPONSE,
  payload,
});
export const deleteAddress = (payload = {}) => ({
  type: types.DELETE_ADDRESS,
  payload,
});
export const getAddressByCustomerId = (payload = {}) => ({
  type: types.GET_ADDRESS,
  payload,
});
export const getAddressByCustomerIdResponse = (payload = []) => ({
  type: types.GET_ADDRESS_RESPONSE,
  payload,
});
export const createBanner = (data = {}) => ({
  type: types.CREATE_BANNER,
  data,
});
export const updateBanner = (data = {}) => ({
  type: types.UPDATE_BANNER,
  data,
});
export const getAllBanner = (payload = {}) => ({
  type: types.GET_ALL_BANNER,
  payload,
});
export const getAllBannerResponse = (payload = []) => ({
  type: types.GET_ALL_BANNER_RESPONSE,
  payload,
});
export const getBannerById = (payload = {}) => ({
  type: types.GET_BANNER,
  payload,
});
export const getBannerByIdResponse = (payload = []) => ({
  type: types.GET_BANNER_RESPONSE,
  payload,
});
export const deleteBanner = (payload = {}) => ({
  type: types.DELETE_BANNER,
  payload,
});
export const getBannersByDefault = (payload = {}) => ({
  type: types.GET_BANNER,
  payload,
});
export const getBannersByDefaultResponse = (payload = []) => ({
  type: types.GET_BANNER_RESPONSE,
  payload,
});
export const getVideoBanner = (payload = {}) => ({
  type: types.GET_BANNER,
  payload,
});
export const getVideoBannerResponse = (payload = []) => ({
  type: types.GET_BANNER_RESPONSE,
  payload,
});
export const getImageBanners = (payload = {}) => ({
  type: types.GET_BANNER,
  payload,
});
export const getImageBannersResponse = (payload = []) => ({
  type: types.GET_BANNER_RESPONSE,
  payload,
});
export const getActiveBanners = (payload = {}) => ({
  type: types.GET_BANNER,
  payload,
});
export const getInActiveBanners = (payload = {}) => ({
  type: types.GET_INACTIVE_BANNER,
  payload,
});
export const getActiveBannersResponse = (payload = []) => ({
  type: types.GET_BANNER_RESPONSE,
  payload,
});
export const createBlogCategory = (data = {}) => ({
  type: types.CREATE_BLOG_CATEGORY,
  data,
});
export const updateBlogCategory = (data = {}) => ({
  type: types.UPDATE_BLOG_CATEGORY,
  data,
});
export const getAllBlogCategory = (payload = {}) => ({
  type: types.GET_ALL_BLOG_CATEGORY,
  payload,
});
export const getAllBlogCategoryResponse = (payload = []) => ({
  type: types.GET_ALL_BLOG_CATEGORY_RESPONSE,
  payload,
});
export const getBlogCategoryById = (payload = {}) => ({
  type: types.GET_BLOG_CATEGORY_BY_ID,
  payload,
});
export const getBlogCategoryByIdResponse = (payload = []) => ({
  type: types.GET_BLOG_CATEGORY_BY_ID_RESPONSE,
  payload,
});
export const deleteBlogCategory = (payload = {}) => ({
  type: types.DELETE_BLOG_CATEGORY,
  payload,
});
export const getActiveBlogCategory = (payload = {}) => ({
  type: types.GET_ACTIVE_BLOG_CATEGORY,
  payload,
});
export const getActiveBlogCategoryResponse = (payload = []) => ({
  type: types.GET_ACTIVE_BLOG_CATEGORY_RESPONSE,
  payload,
});

export const createBlogs = (data = {}) => ({ type: types.CREATE_BLOGS, data });
export const updateBlogs = (data = {}) => ({ type: types.UPDATE_BLOGS, data });
export const getAllBlogs = (payload = {}) => ({
  type: types.GET_ALL_BLOGS,
  payload,
});
export const getAllBlogsResponse = (payload = []) => ({
  type: types.GET_ALL_BLOGS_RESPONSE,
  payload,
});
export const getBlogsById = (payload = {}) => ({
  type: types.GET_BLOGS,
  payload,
});
export const getBlogsByIdResponse = (payload = []) => ({
  type: types.GET_BLOGS_RESPONSE,
  payload,
});
export const deleteBlogs = (payload = {}) => ({
  type: types.DELETE_BLOGS,
  payload,
});

// ACTIVE BLOG
export const getActiveBlogs = (payload = {}) => ({
  type: types.GET_ACTIVE_BLOG,
  payload,
});
export const getActiveBlogsResponse = (payload = []) => ({
  type: types.GET_ACTIVE_BLOG_RESPONSE,
  payload,
});
// INACTIVE BLOG
export const getInActiveBlogs = (payload = {}) => ({
  type: types.GET_INACTIVE_BLOG,
  payload,
});
export const getInActiveBlogsRespose = (payload = []) => ({
  type: types.GET_INACTIVE_BLOG_RESPONSE,
  payload,
});
export const createCategory = (data = {}) => ({
  type: types.CREATE_CATEGORY,
  data,
});
export const updateCategory = (data = {}) => ({
  type: types.UPDATE_CATEGORY,
  data,
});
export const getCategoryById = (payload = {}) => ({
  type: types.GET_CATEGORY,
  payload,
});
export const getCategoryByIdResponse = (payload = []) => ({
  type: types.GET_CATEGORY_RESPONSE,
  payload,
});
export const getAllCategory = (payload = {}) => ({
  type: types.GET_ALL_CATEGORY,
  payload,
});
export const getAllCategoryResponse = (payload = []) => ({
  type: types.GET_ALL_CATEGORY_RESPONSE,
  payload,
});
export const deleteCategory = (payload = {}) => ({
  type: types.DELETE_CATEGORY,
  payload,
});
export const createCustomer = (data = {}) => ({
  type: types.CREATE_CUSTOMER,
  data,
});
export const getAllCustomer = (payload = {}) => ({
  type: types.GET_ALL_CUSTOMER,
  payload,
});
export const getAllCustomerResponse = (payload = []) => ({
  type: types.GET_ALL_CUSTOMER_RESPONSE,
  payload,
});
export const getCustomerById = (payload = {}) => ({
  type: types.GET_CUSTOMER_ID,
  payload,
});
export const getCustomerByIdResponse = (payload = []) => ({
  type: types.GET_CUSTOMER_RESPONSE,
  payload,
});
export const deleteCustomer = (payload = {}) => ({
  type: types.DELETE_CUSTOMER,
  payload,
});
export const updateCustomer = (data = {}) => ({
  type: types.UPDATE_CUSTOMER,
  data,
});
export const changeMobileNumber = (payload = {}) => ({
  type: types.GET_CUSTOMER,
  payload,
});
export const changeMobileNumberResponse = (payload = []) => ({
  type: types.GET_CUSTOMER_RESPONSE,
  payload,
});
export const login = (data = {}) => ({
  type: types.CREATE_CUSTOMER,
  data,
});

export const validateOTP = (data = {}) => ({
  type: types.VALIDATE_OTP,
  data,
});
export const getWishlistProducts = (payload = {}) => ({
  type: types.GET_CUSTOMER,
  payload,
});
export const getWishlistProductsResponse = (payload = []) => ({
  type: types.GET_CUSTOMER_RESPONSE,
  payload,
});

export const getCartByCustomerId = (payload = {}) => ({
  type: types.GET_CUSTOMER,
  payload,
});
export const getCartByCustomerIdResponse = (payload = []) => ({
  type: types.GET_CUSTOMER_RESPONSE,
  payload,
});
export const updateProductQuantityFromCart = (data = {}) => ({
  type: types.CREATE_CUSTOMER,
  data,
});
export const updateUserPassword = (data = {}) => ({
  type: types.UPDATE_USER_PASSWORD,
  data,
});
export const removeProductFromCart = (data = {}) => ({
  type: types.CREATE_CUSTOMER,
  data,
});
export const createOffer = (data = {}) => ({ type: types.CREATE_OFFER, data });
export const getAllOffer = (payload = {}) => ({
  type: types.GET_ALL_OFFER,
  payload,
});
export const getAllOfferResponse = (payload = []) => ({
  type: types.GET_ALL_OFFER_RESPONSE,
  payload,
});
export const getOfferById = (payload = {}) => ({
  type: types.GET_OFFER,
  payload,
});
export const getOfferByIdResponse = (payload = []) => ({
  type: types.GET_OFFER_RESPONSE,
  payload,
});
export const updateOffer = (data = {}) => ({ type: types.UPDATE_OFFER, data });
export const deleteOffer = (payload = {}) => ({
  type: types.DELETE_OFFER,
  payload,
});
export const getActiveOffers = (payload = {}) => ({
  type: types.GET_OFFER,
  payload,
});
export const getActiveOffersResponse = (payload = []) => ({
  type: types.GET_OFFER_RESPONSE,
  payload,
});
export const createOrders = (data = {}) => ({
  type: types.CREATE_ORDERS,
  data,
});
export const updateOrders = (data = {}) => ({
  type: types.UPDATE_ORDERS,
  data,
});
export const getAllOrders = (payload = {}) => ({
  type: types.GET_ALL_ORDERS,
  payload,
});

export const getAllOrdersResponse = (payload = []) => ({
  type: types.GET_ALL_ORDERS_RESPONSE,
  payload,
});
export const getOrdersById = (payload = {}) => ({
  type: types.GET_ORDERS,
  payload,
});
export const getOrdersByIdResponse = (payload = []) => ({
  type: types.GET_ORDERS_RESPONSE,
  payload,
});
export const deleteOrders = (payload = {}) => ({
  type: types.DELETE_ORDERS,
  payload,
});
export const getPendingOrders = (payload = {}) => ({
  type: types.GET_PENDING_ORDERS,
  payload,
});
export const getPendingOrdersResponse = (payload = []) => ({
  type: types.GET_ORDERS_RESPONSE,
  payload,
});
export const getPackedOrders = (payload = {}) => ({
  type: types.GET_PACKED_ORDERS,
  payload,
});
export const getPackedOrdersResponse = (payload = []) => ({
  type: types.GET_ALL_ORDERS_RESPONSE,
  payload,
});
export const getShippedOrders = (payload = {}) => ({
  type: types.GET_SHIPPED_ORDERS,
  payload,
});
export const getShippedOrdersResponse = (payload = []) => ({
  type: types.GET_ALL_ORDERS_RESPONSE,
  payload,
});
export const getDeliveredOrders = (payload = {}) => ({
  type: types.GET_DELIVERY_ORDERS,
  payload,
});
export const getDeliveredOrdersResponse = (payload = []) => ({
  type: types.GET_ALL_ORDERS_RESPONSE,
  payload,
});

export const getCartBundleIdOrders = (payload = {}) => ({
  type: types.GET_CART_BUNDLE_ID_ORDERS,
  payload,
});
export const getCartBundleIdOrdersResponse = (payload = {}) => ({
  type: types.GET_CART_BUNDLE_ID_ORDERS_RESPONSE,
  payload,
});

export const getCustomerTotalOrdersQuantity = (payload = {}) => ({
  type: types.GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY,
  payload,
});
export const getCustomerTotalOrdersQuantityResponse = (payload = {}) => ({
  type: types.GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY_RESPONSE,
  payload,
});

export const getAllOrdersByCartBundleId = (payload = {}) => ({
  type: types.GET_ALL_ORDERS_BY_CARTBUNDLEID,
  payload,
});
export const getAllOrdersByCartBundleIdResponse = (payload = []) => ({
  type: types.GET_ALL_ORDERS_BY_CARTBUNDLEID_RESPONSE,
  payload,
});

export const getAllCompletedOrdersByCartBundle = (payload = {}) => ({
  type: types.GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES,
  payload,
});
export const getAllCompletedOrdersByCartBundleResponse = (payload = []) => ({
  type: types.GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES_RESPONSE,
  payload,
});

export const updateOrderStatusByCartBundleId = (payload = {}) => ({
  type: types.UPDATE_ORDERS_STATUS_BY_CARTBUNDLEID,
  payload,
});

// getPendingCount
export const getPendingCount = (payload = {}) => ({
  type: types.GET_PENDING_COUNT,
  payload,
});
export const getPendingCountResponse = (payload = {}) => ({
  type: types.GET_PENDING_COUNT_RESPONSE,
  payload,
});

//getDeliveredCount
export const getDeliveredCount = (payload = {}) => ({
  type: types.GET_DELIVERED_COUNT,
  payload,
});
export const getDeliveredCountResponse = (payload = {}) => ({
  type: types.GET_DELIVERED_COUNT_RESPONSE,
  payload,
});
//getShippedCount
export const getShippedCount = (payload = {}) => ({
  type: types.GET_SHIPPED_COUNT,
  payload,
});
export const getShippedCountResponse = (payload = {}) => ({
  type: types.GET_SHIPPED_COUNT_RESPONSE,
  payload,
});
//getPackedCount
export const getPackedCount = (payload = {}) => ({
  type: types.GET_PACKED_COUNT,
  payload,
});
export const getPackedCountResponse = (payload = {}) => ({
  type: types.GET_PACKED_COUNT_RESPONSE,
  payload,
});
//getCancelledCount
export const getCancelledCount = (payload = {}) => ({
  type: types.GET_CANCELLED_COUNT,
  payload,
});
export const getCancelledCountResponse = (payload = {}) => ({
  type: types.GET_CANCELLED_COUNT_RESPONSE,
  payload,
});

export const getCancelledOrders = (payload = {}) => ({
  type: types.GET_ORDERS,
  payload,
});
export const getCancelledOrdersResponse = (payload = []) => ({
  type: types.GET_ORDERS_RESPONSE,
  payload,
});
export const getOrdersByCustomerId = (payload = {}) => ({
  type: types.GET_ORDERS_BY_CUSTOMER_ID,
  payload,
});
export const getOrdersByCustomerIdResponse = (payload = []) => ({
  type: types.GET_ORDERS_RESPONSE,
  payload,
});
export const addProductIdToWishlist = (payload = {}) => ({
  type: types.GET_CUSTOMER,
  payload,
});
export const addProductIdToWishlistResponse = (payload = []) => ({
  type: types.GET_CUSTOMER_RESPONSE,
  payload,
});
export const createOrdersWithProducts = (data = {}) => ({
  type: types.CREATE_ORDERS,
  data,
});
export const getOrdersByCartBundleId = (payload = {}) => ({
  type: types.GET_ORDERS_BY_BUNDLE_ID,
  payload,
});
export const getOrdersByCartBundleIdResponse = (payload = []) => ({
  type: types.GET_ALL_ORDERS_RESPONSE,
  payload,
});
export const createProduct = (data = {}) => ({
  type: types.CREATE_PRODUCT,
  data,
});
export const getAllProduct = (payload = {}) => ({
  type: types.GET_ALL_PRODUCT,
  payload,
});
export const getAllProductResponse = (payload = []) => ({
  type: types.GET_ALL_PRODUCT_RESPONSE,
  payload,
});

// top selling product
export const getTopSellingProducts = (payload = {}) => ({
  type: types.GET_TOP_SELLING_PRODUCTS,
  payload,
});

export const getTopSellingProductsResponse = (payload = []) => ({
  type: types.GET_TOP_SELLING_PRODUCTS_RESPONSE,
  payload,
});

export const getProductById = (payload = {}) => ({
  type: types.GET_PRODUCT_BY_ID,
  payload,
});
export const getProductByIdResponse = (payload = []) => ({
  type: types.GET_PRODUCT_RESPONSE,
  payload,
});
export const deleteProduct = (payload = {}) => ({
  type: types.DELETE_PRODUCT,
  payload,
});
export const updateProduct = (data = {}) => ({
  type: types.UPDATE_PRODUCT,
  data,
});
export const getProductByCategoryId = (payload = {}) => ({
  type: types.GET_PRODUCT_BY_CATEGORY_ID,
  payload,
});
export const getProductByCategoryIdResponse = (payload = []) => ({
  type: types.GET_PRODUCT_BY_CATEGORY_ID_RESPONSE,
  payload,
});

export const getAllProductByCategoryId = (payload = {}) => ({
  type: types.GET_ALL_PRODUCT_BY_CATEGORY_ID,
  payload,
});
export const getAllProductByCategoryIdResponse = (payload = []) => ({
  type: types.GET_ALL_PRODUCT_BY_CATEGORY_ID_RESPONSE,
  payload,
});

export const getActiveProducts = (payload = {}) => ({
  type: types.GET_ACTIVE_PRODUCTS,
  payload,
});
export const getActiveProductsResponse = (payload = []) => ({
  type: types.GET_ACTIVE_PRODUCTS_RESPONSE,
  payload,
});
export const searchProductByKeywords = (payload = {}) => ({
  type: types.GET_PRODUCT,
  payload,
});
export const searchProductByKeywordsResponse = (payload = []) => ({
  type: types.GET_PRODUCT_RESPONSE,
  payload,
});
export const addProductsInCart = (payload = {}) => ({
  type: types.GET_PRODUCT,
  payload,
});
export const addProductsInCartResponse = (payload = []) => ({
  type: types.GET_PRODUCT_RESPONSE,
  payload,
});
export const getProductByProductCode = (payload = {}) => ({
  type: types.GET_PRODUCT,
  payload,
});
export const getProductByProductCodeResponse = (payload = []) => ({
  type: types.GET_PRODUCT_RESPONSE,
  payload,
});
export const bestSellingProducts = (payload = {}) => ({
  type: types.GET_PRODUCT,
  payload,
});
export const bestSellingProductsResponse = (payload = []) => ({
  type: types.GET_PRODUCT_RESPONSE,
  payload,
});
export const createReview = (data = {}) => ({
  type: types.CREATE_REVIEW,
  data,
});
export const updateReview = (data = {}) => ({
  type: types.UPDATE_REVIEW,
  data,
});
export const getAllReview = (payload = {}) => ({
  type: types.GET_ALL_REVIEW,
  payload,
});
export const getAllReviewResponse = (payload = []) => ({
  type: types.GET_ALL_REVIEW_RESPONSE,
  payload,
});
export const getReviewById = (payload = {}) => ({
  type: types.GET_REVIEW,
  payload,
});
export const getReviewByIdResponse = (payload = []) => ({
  type: types.GET_REVIEW_RESPONSE,
  payload,
});
export const deleteReview = (payload = {}) => ({
  type: types.DELETE_REVIEW,
  payload,
});
export const addReplyToReview = (payload = {}) => ({
  type: types.GET_REVIEW,
  payload,
});
export const addReplyToReviewResponse = (payload = []) => ({
  type: types.GET_REVIEW_RESPONSE,
  payload,
});
export const getReviewsByProductId = (payload = {}) => ({
  type: types.GET_REVIEW,
  payload,
});
export const getReviewsByProductIdResponse = (payload = []) => ({
  type: types.GET_REVIEW_RESPONSE,
  payload,
});

//LOGIN

export const loginUser = (data = {}) => ({
  type: types.LOGIN_USER,
  data,
});

export const loginUserResponse = (payload = []) => ({
  type: types.LOGIN_USER_RESPONSE,
  payload,
});

export const createUser = (data = {}) => ({ type: types.CREATE_USER, data });

export const getUserById = (payload = {}) => ({
  type: types.GET_USER,
  payload,
});
export const getUserByIdResponse = (payload = []) => ({
  type: types.GET_USER_RESPONSE,
  payload,
});
export const getAllUser = (payload = {}) => ({
  type: types.GET_ALL_USER,
  payload,
});
export const getAllUserResponse = (payload = []) => ({
  type: types.GET_ALL_USER_RESPONSE,
  payload,
});
export const updateUser = (data = {}) => ({ type: types.UPDATE_USER, data });
export const deleteUser = (payload = {}) => ({
  type: types.DELETE_USER,
  payload,
});
export const createCalculation = (data = {}) => ({
  type: types.CREATE_CALCULATION,
  data,
});
export const getAllCalculation = (payload = {}) => ({
  type: types.GET_ALL_CALCULATION,
  payload,
});
export const getAllCalculationResponse = (payload = []) => ({
  type: types.GET_ALL_CALCULATION_RESPONSE,
  payload,
});
export const getCalculationById = (payload = {}) => ({
  type: types.GET_CALCULATION,
  payload,
});
export const getCalculationByIdResponse = (payload = []) => ({
  type: types.GET_CALCULATION_RESPONSE,
  payload,
});
export const deleteCalculation = (payload = {}) => ({
  type: types.DELETE_CALCULATION,
  payload,
});
export const updateCalculation = (data = {}) => ({
  type: types.UPDATE_CALCULATION,
  data,
});
export const getCalculationByCardBundleId = (payload = {}) => ({
  type: types.GET_CALCULATION_BY_CARDBUNDLE_ID,
  payload,
});
export const sendOtpToUserNumber = (data = {}) => ({
  type: types.CREATE_OTP,
  data,
});
export const sendOtpCustomertNumber = (data = {}) => ({
  type: types.CREATE_OTP,
  data,
});
export const createOrder = (data = {}) => ({
  type: types.CREATE_RAZORPAY,
  data,
});
export const verifyOrder = (data = {}) => ({
  type: types.CREATE_RAZORPAY,
  data,
});
export const fetchPayment = (payload = {}) => ({
  type: types.FETCH_PAYMENT,
  payload,
});
export const paymentDetailsResponses = (data = {}) => ({
  type: types.PEYMENT_DETAILS_RESPONSES,
  data,
});

export const authUser = (data = {}) => ({
  type: types.CREATE_AUTH,
  data,
});

export const authUserResponse = (payload = {}) => ({
  type: types.AUTH_USER_RESPONSE,
  payload,
});

export const getAllContactAs = (payload = []) => ({
  type: types.GET_ALL_CONTACT_AS,
  payload,
});

export const getAllContactAsResponse = (payload = []) => ({
  type: types.GET_ALL_CONTACT_AS_RESPONSE,
  payload,
});

export const createState = (data = {}) => ({
  type: types.CREATE_STATE,
  data,
});

export const updateState = (data = {}) => ({
  type: types.UPDATE_STATE,
  data,
});

export const getAllStates = (payload = {}) => ({
  type: types.GET_ALL_STATE,
  payload,
});
export const getAllStatesResponse = (payload = []) => ({
  type: types.GET_ALL_STATE_RESPONSE,
  payload,
});
export const getStateById = (payload = {}) => ({
  type: types.GET_STATE,
  payload,
});
export const getStateByIdResponse = (payload = []) => ({
  type: types.GET_STATE_RESPONSE,
  payload,
});
export const deleteState = (payload = {}) => ({
  type: types.DELETE_STATE,
  payload,
});

// UI

export const setPanel = (payload = {}) => ({
  type: types.SET_PANEL,
  payload,
});
export const modifyPanel = (payload = {}) => ({
  type: types.MODIFY_PANEL,
  payload,
});

export const setTheme = (payload) => ({
  type: types.SET_THEME,
  payload,
});

// Delhivery
export const schedulePickup = (payload) => ({
  type: types.SCHEDULE_PICKUP,
  payload,
});
export const createShipment = (payload) => ({
  type: types.CREATE_SHIPMENT,
  payload,
});
export const getShipment = (payload) => ({
  type: types.GET_SHIPMENT,
  payload,
});
export const getShipmentResponses = (payload) => ({
  type: types.GET_SHIPMENT_RESPONSES,
  payload,
});
export const getPackageDetails = (payload) => ({
  type: types.GET_PACKAGE_DETAILS,
  payload,
});
export const getPackageDetailsResponses = (payload) => ({
  type: types.GET_PACKAGE_DETAILS_RESPONSES,
  payload,
});
export const updatePacakgeDetails = (payload) => ({
  type: types.UPDATE_PACKAGE_DETAILS,
  payload,
});
export const getReceipt = (payload) => ({
  type: types.GET_RECEIPT,
  payload,
});

export const createSupportTicket = (data = {}) => ({
  type: types.CREATE_SUPPORT_TICKET,
  data,
});
export const getAllSupportTicket = (payload = {}) => ({
  type: types.GET_ALL_SUPPORT_TICKET,
  payload,
});
export const getAllSupportTicketResponse = (payload = []) => ({
  type: types.GET_ALL_SUPPORT_TICKET_RESPONSE,
  payload,
});
export const getSupportTicketById = (payload = {}) => ({
  type: types.GET_SUPPORT_TICKET_BY_ID,
  payload,
});
export const getSupportTicketByIdResponse = (payload = []) => ({
  type: types.GET_SUPPORT_TICKET_BY_ID_RESPONSE,
  payload,
});
export const updateSupportTicket = (data = {}) => ({
  type: types.UPDATE_SUPPORT_TICKET,
  data,
});
export const deleteSupportTicket = (payload = {}) => ({
  type: types.DELETE_SUPPORT_TICKET,
  payload,
});
export const getSupportTicketsByStatus = (payload = {}) => ({
  type: types.GET_SUPPORT_TICKETS_BY_STATUS,
  payload,
});
export const getSupportTicketsByStatusResponse = (payload = []) => ({
  type: types.GET_SUPPORT_TICKETS_BY_STATUS_RESPONSE,
  payload,
});
export const getOldMessages = (payload) => ({
  type: types.GET_OLD_MESSAGES,
  payload,
});
export const getOldMessagesResponse = (payload = []) => ({
  type: types.GET_OLD_MESSAGES_RESPONSES,
  payload,
});
export const addChatMessage = (data = {}) => ({
  type: types.ADD_CHAT_MESSAGE,
  data,
});
export const updateUnSeenChat = (data = {}) => ({
  type: types.UPDATE_UNSEEN_CHAT,
  data,
});
export const endChatSession = (data = {}) => ({
  type: types.END_CHAT_SESSION,
  data,
});

const actions = {
  getAllContactAsResponse,
  getAllContactAs,
  authUser,
  authUserResponse,
  addProductIdToWishlist,
  addProductIdToWishlist,
  addProductIdToWishlistResponse,
  addProductIdToWishlistResponse,
  addProductsInCart,
  addProductsInCartResponse,
  addReplyToReview,
  addReplyToReviewResponse,
  bestSellingProducts,
  bestSellingProductsResponse,
  changeMobileNumber,
  changeMobileNumberResponse,
  createAddress,
  createBanner,
  getInActiveBanners,
  createBlogCategory,
  createBlogs,
  createCalculation,
  createCategory,
  createCustomer,
  createOffer,
  createOrder,
  createOrders,
  createOrdersWithProducts,
  createProduct,
  createReview,
  createUser,
  deleteAddress,
  deleteBanner,
  deleteBlogCategory,
  deleteBlogs,
  deleteCalculation,
  deleteCategory,
  deleteCustomer,
  deleteOffer,
  deleteOrders,
  deleteProduct,
  deleteReview,
  deleteUser,
  getActiveBanners,
  getActiveBannersResponse,
  getActiveOffers,
  getActiveOffersResponse,
  getAddressByCustomerId,
  getAddressByCustomerIdResponse,
  getAddressById,
  getAddressByIdResponse,
  getAllAddress,
  getAllAddressResponse,
  getAllBanner,
  getAllBannerResponse,
  getAllBlogCategory,
  getAllBlogCategoryResponse,
  getAllBlogs,
  getAllBlogsResponse,
  getAllCalculation,
  getAllCalculationResponse,
  getAllCategory,
  getAllCategoryResponse,
  getAllCustomer,
  getAllCustomerResponse,
  getAllOffer,
  getAllOfferResponse,
  getAllOrders,
  getAllOrdersResponse,
  getAllProduct,
  getAllProductResponse,
  getAllReview,
  getAllReviewResponse,
  getAllUser,
  getAllUserResponse,
  getBannerById,
  getBannerByIdResponse,
  getBannersByDefault,
  getBannersByDefaultResponse,
  getBlogCategoryById,
  getBlogCategoryByIdResponse,
  getBlogsById,
  getBlogsByIdResponse,
  getCalculationById,
  getCalculationByIdResponse,
  getCancelledOrders,
  getCancelledOrdersResponse,
  getCartByCustomerId,
  getCartByCustomerIdResponse,
  getCategoryById,
  getCategoryByIdResponse,
  getCustomerById,
  getCustomerByIdResponse,
  getDeliveredOrders,
  getDeliveredOrdersResponse,
  getImageBanners,
  getImageBannersResponse,
  getOfferById,
  getOfferByIdResponse,
  getOrdersByCartBundleId,
  getOrdersByCartBundleIdResponse,
  getOrdersByCustomerId,
  getOrdersByCustomerIdResponse,
  getOrdersById,
  getOrdersByIdResponse,
  getPackedOrders,
  getPackedOrdersResponse,
  getPendingOrders,
  getPendingOrdersResponse,
  getProductByCategoryId,
  getProductByCategoryIdResponse,
  getAllProductByCategoryIdResponse,
  getActiveProducts,
  getActiveProductsResponse,
  getProductById,
  getProductByIdResponse,
  getProductByProductCode,
  getProductByProductCodeResponse,
  getReviewById,
  getReviewByIdResponse,
  getReviewsByProductId,
  getReviewsByProductIdResponse,
  getShippedOrders,
  getShippedOrdersResponse,
  getUserById,
  getUserByIdResponse,
  getVideoBanner,
  getVideoBannerResponse,
  getWishlistProducts,
  getWishlistProductsResponse,
  login,
  login,
  login,
  removeProductFromCart,
  searchProductByKeywords,
  searchProductByKeywordsResponse,
  sendOtpCustomertNumber,
  sendOtpToUserNumber,
  updateAddress,
  updateBanner,
  updateBlogCategory,
  updateBlogs,
  updateCalculation,
  getCalculationByCardBundleId,
  updateCategory,
  updateCustomer,
  updateOffer,
  updateOrders,
  updateProduct,
  updateProductQuantityFromCart,
  updateReview,
  updateUser,
  updateUserPassword,
  validateOTP,
  verifyOrder,
  fetchPayment,
  paymentDetailsResponses,
  getTotalOrdersResponse,
  getTotalSalesResponse,
  getTopSellingProductsResponse,
  getPendingCountResponse,
  getCancelledCountResponse,
  getDeliveredCountResponse,
  getShippedCountResponse,
  getPackedCountResponse,
  getInActiveBlogsRespose,
  getActiveBlogsResponse,
  createState,
  updateState,
  getAllStates,
  getAllStatesResponse,
  getStateById,
  getStateByIdResponse,
  deleteState,

  //LOGIN
  loginUser,
  // ui
  setPanel,
  modifyPanel,
  setTheme,
  getCartBundleIdOrdersResponse,
  getCustomerTotalOrdersQuantityResponse,
  getCustomerTotalOrdersQuantityResponse,
  getAllCompletedOrdersByCartBundleResponse,

  // Delhivery
  schedulePickup,
  createShipment,
  getShipment,
  getShipmentResponses,
  getPackageDetails,
  getPackageDetailsResponses,
  updatePacakgeDetails,
  getReceipt,

  //support ticket

  addChatMessage,
  createSupportTicket,
  deleteSupportTicket,
  getAllSupportTicket,
  getAllSupportTicketResponse,
  getSupportTicketById,
  getSupportTicketByIdResponse,
  getSupportTicketsByStatus,
  getSupportTicketsByStatusResponse,
  updateSupportTicket,
  getOldMessages,
  getOldMessagesResponse,
  updateUnSeenChat,
  endChatSession,
};

export default actions;
